import React, { useState, useEffect } from 'react';
import { FaShieldAlt, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const AgeVerification: React.FC = () => {
  const [isVerified, setIsVerified] = useState<boolean>(() => {
    return localStorage.getItem('ageVerified') === 'true';
  });

  useEffect(() => {
    if (isVerified) {
      document.body.style.overflow = '';
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [isVerified]);

  const handleVerify = (isOver18: boolean) => {
    if (isOver18) {
      localStorage.setItem('ageVerified', 'true');
      setIsVerified(true);
    } else {
      // Redirect to responsible gambling page
      alert('You must be 18 or older to access this website. Please visit responsible gambling resources for support.');
      window.location.href = 'https://www.gambleaware.org';
    }
  };

  if (isVerified) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-titanium-950/95 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="glass rounded-2xl p-8 max-w-md w-full border-2 border-neon-blue/30 shadow-2xl">
        <div className="text-center">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-neon-blue to-neon-purple rounded-full flex items-center justify-center">
            <FaShieldAlt className="text-4xl text-white" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-4">Age Verification</h2>
          <p className="text-gray-300 mb-8 text-lg">
            You must be 18 or older to access this website. Please confirm your age to continue.
          </p>
          <div className="space-y-4">
            <button
              onClick={() => handleVerify(true)}
              className="w-full bg-gradient-to-r from-neon-blue to-neon-purple hover:from-neon-purple hover:to-neon-pink text-white font-bold py-4 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
            >
              <FaCheckCircle className="text-xl" />
              Yes, I am 18 or older
            </button>
            <button
              onClick={() => handleVerify(false)}
              className="w-full bg-titanium-800 hover:bg-titanium-700 border-2 border-red-500/50 hover:border-red-500 text-white font-bold py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2"
            >
              <FaTimesCircle className="text-xl" />
              No, I am under 18
            </button>
          </div>
          <p className="text-gray-500 text-xs mt-6">
            By clicking "Yes", you confirm that you meet the legal age requirement for gambling in your jurisdiction.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;


